import { Color } from "three";
import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";

/*
    Parses CSV files into an arr and does a call back function on the array after parsing
*/
// also parses .rmoo
export function parseCSV(file, func) {
    let arr;
    let fr = new FileReader();
    fr.onload = function () {
        let data = fr.result;
        arr = data.split(/\r\n|\n/).map((line) => {
            return line.split(/,|;/);
        })
        // console.log(arr[0]);
        func(arr);
    }
    fr.readAsText(file);
}

/*
    Exports a robot's current configuration
    Not really used anymore
*/
// https://stackoverflow.com/questions/45611674/export-2d-javascript-array-to-excel-sheet
export function exportToCsv(data, filename) {
    let str = "";
    data.forEach((row) => {
        for (let i = 0; i < row.length - 1; i++) {
            str += row[i] + ",";
        }
        str += row[row.length - 1] + "\r\n";
    });
    str = "data:application/csv," + encodeURIComponent(str);
    let x = document.createElement("A");
    x.setAttribute("href", str);
    x.setAttribute("download", filename);
    document.body.appendChild(x);
    x.click();
    document.body.removeChild(x);
}

/**
 * 
 * @param {object} data Data to turn into JSON
 * @param {string} filename Name of exported file
 */
export function exportToJson(data, filename) {
    let str = "data:application/json;charset=utf-8," + encodeURIComponent(data);
    let x = document.createElement("A");
    x.setAttribute("href", str);
    x.setAttribute("download", filename);
    document.body.appendChild(x);
    x.click();
    document.body.removeChild(x);
}


/**
 * 
 * @param {THREE.Scene} scene Scene to export
 */
export function exportSceneToGLTF(scene) {
    let link = document.createElement( 'a' );
    document.body.appendChild( link );
    let exporter = new GLTFExporter();
    let options = {
        trs: false,
        onlyVisible: true,
        truncateDrawRange: false,
        binary: false,
        forceIndices: true,
        maxTextureSize: Infinity // To prevent NaN value
    }
    // https://github.com/mrdoob/three.js/blob/master/examples/misc_exporter_gltf.html
    let save = (blob, filename) => {
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
    }
    let saveString = (text, filename) => {
        save(new Blob([text], { type: 'text/plain' }), filename);
    }
    let saveArrayBuffer = (buffer, filename) => {
        save(new Blob([buffer], { type: 'application/octet-stream' }), filename);
    }
    exporter.parse(scene, function (result) {
        if (result instanceof ArrayBuffer) {
            saveArrayBuffer(result, 'scene.glb');
        } else {
            let output = JSON.stringify(result, null, 2);
            console.log(output);
            saveString(output, 'scene.gltf');
        }
    }, options);
}

// https://stackoverflow.com/questions/44070437/how-to-get-a-file-or-blob-from-an-url-in-javascript
export function fetchFromURL(url, func) {
    fetch(url)
        .then(res => res.blob()) // Gets the response and returns it as a blobs
        .then(blob => {
            // temp
            func(blob);
        }
        );
}

// t should be between 0 and 1
export function lerp(a, b, t) {
    return a + (b - a) * t;
}

// https://www.jacklmoore.com/notes/rounding-in-javascript/
export function round(value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}

export function getColorFromRamp(colors, t) {
    t *= (colors.length - 1);
    let index = Math.floor(t);
    let u = t - index;
    let color1 = colors[index];
    let color2 = colors[(index < colors.length - 1 ? index + 1 : index)];
    return new Color(
        lerp(color1.r, color2.r, u),
        lerp(color1.g, color2.g, u),
        lerp(color1.b, color2.b, u)
    )
}

/**
 * 
 * @param {2D array} matrix n*n matrix to transpose
 * @returns tranposed matrix
 */
export function transposeMatrix(matrix) {
    let tm = []
    let w = matrix.length;
    let h = matrix[0].length;
    for(let i = 0; i < h; i++) {
        let row = []
        for(let k = 0; k < w; k++) {
            row.push(matrix[k][i])
        }
        tm.push(row)
    }
    return tm
}